import { render, staticRenderFns } from "./SupportAgent.vue?vue&type=template&id=6a70d210&scoped=true"
import script from "./SupportAgent.vue?vue&type=script&lang=js"
export * from "./SupportAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70d210",
  null
  
)

export default component.exports